var form = document.querySelector(".search-bar");
	form.addEventListener('focusin', (e) => {
		if( document.querySelector('.search-bar__input').value.indexOf('\\*') != -1){
			var result = document.querySelector('.search-bar__input').value.replace(/\\\*/g, '');
			document.querySelector('.search-bar__input').value = result;
        }
    });

	form.addEventListener("submit", function(event) {
	//var input = document.querySelector(".search-bar__input");
	if( document.querySelector('.search-bar__input').value.indexOf('\\*') != -1) {
    }else{
		document.querySelector('.search-bar__input').value += "\\*";
	}
});

var form2 = document.querySelector(".search-bar2");
	form2.addEventListener('focusin', (e) => {
		if( document.querySelector('.search-bar2__input').value.indexOf('\\*') != -1){
			var result = document.querySelector('.search-bar2__input').value.replace(/\\\*/g, '');
			document.querySelector('.search-bar2__input').value = result;
        }
    });

	form2.addEventListener("submit", function(event) {
	//var input = document.querySelector(".search-bar2__input");
	if( document.querySelector('.search-bar2__input').value.indexOf('\\*') != -1) {
    }else{
		document.querySelector('.search-bar2__input').value += "\\*";
	}
});